import { Box, Stack, Typography } from "@mui/material";
import { ReactNode } from "react";

export type EmptyStateCardProps = {
  image: string;
  title: string;
  body: string;
  action?: ReactNode;
};

export const EmptyStateCard = ({
  image,
  title,
  body,
  action,
}: EmptyStateCardProps) => (
  <Stack alignItems="center" rowGap=".5rem" paddingY="1.5rem">
    <Box
      component="img"
      src={image}
      alt=""
      sx={{ width: "5rem", height: "5rem" }}
    />
    <Typography
      variant="cardBodyRegular"
      sx={{ display: "block", fontWeight: 600 }}
    >
      {title}
    </Typography>
    <Typography variant="cardBodyRegular" color="text.secondary">
      {body}
    </Typography>
    {action}
  </Stack>
);
